import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import TableTab from "../../tabs/table-tab";
import { WizardStepLayout } from '../../wizard/wizard-summary-layout';
import { DEF_PG_SIZE_SUB_TABS } from "@/constants/maximum-page-size";
import { TableColumn } from "@/models/table/TableColumn";
import { SearchTerm } from "@/models/search/SearchTerm";
import { Lookup } from "@/models/Lookup";

interface AssignStepStepProps {
    dataMethod: (listParameter?: any) => Promise<any>;
    assigningTitle:string;
    tableColumns: TableColumn[],
    searchColumns: SearchTerm[],
    lookup?: Lookup[],
    onNext: (e: any) => void;
    selectedIds: string[];
    selectedRows: any[];
    setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
    setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
    originalSelectedIds: string[];
    setTotalSelected: React.Dispatch<React.SetStateAction<number>>;
}

const AssignStep: FC<AssignStepStepProps> = ({ dataMethod, assigningTitle, onNext, tableColumns, searchColumns, lookup, selectedIds, selectedRows, setSelectedIds, setSelectedRows, originalSelectedIds, setTotalSelected }) => {
    const { setFieldValue } = useFormikContext<any>();

    const getTotalSelected = (newSelectedIds: string[]): number => {
        const toBeUnassigned = originalSelectedIds.filter((id) => !newSelectedIds.includes(id));
        const toBeAssigned = newSelectedIds.filter((id) => !originalSelectedIds.includes(id));
        return toBeAssigned.length + toBeUnassigned.length;
    }

    const onLocalNext = () => {
        if (getTotalSelected(selectedIds) > 0) {
            setFieldValue("selectedRows", selectedRows);
            setFieldValue("selectedIds", selectedIds)
            onNext({});
        }
    };

    return <WizardStepLayout onNext={onLocalNext} nextDisabled={getTotalSelected(selectedIds) === 0}>
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <TableContextProvider
                dataMethod={dataMethod}
                tableDescriptor={tableColumns}
                searchDescriptor={searchColumns}
                useTable
                usePagination
                useFilter
                useSearch
                maxPageSize={DEF_PG_SIZE_SUB_TABS}
                useSort
                canExportReport={false}
                lookup={lookup}>
                <TableTab
                    title={assigningTitle}
                    selectRows={true}
                    selectedIds={selectedIds}
                    setSelectedIds={(selectedIds) => {
                        setSelectedIds(selectedIds);
                        setTotalSelected(getTotalSelected(selectedIds));
                    }}
                    setSelectedRows={setSelectedRows}
                    selectedRows={selectedRows}
                    cyName="AssignStep"/>
            </TableContextProvider>
        </div>
    </WizardStepLayout>
}

export default AssignStep;